(function guestsSelectorWrapper() {
  // eslint-disable-next-line no-unused-vars
  window.guestsSelector = function guestsSelector(rooms) {
    const largeBreakpoint = 992;
    return {
      expanded: false,
      rooms: [],
      activeRoom: false,
      tooltip: {
        index: null,
        property: null,
        message: null,
      },
      totalRooms: 1,
      generateUUID() {
        if (typeof crypto.randomUUID === 'function') {
          return crypto.randomUUID();
        }
        // Fallback (see ticket on commit details)
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
          (
            c ^ // eslint-disable-line no-bitwise
            // eslint-disable-next-line no-bitwise
            (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
          ).toString(16),
        );
      },
      setRooms(rooms) {
        rooms.forEach(room => {
          this.rooms.push({
            // A GUID is added to each room to prevent issues when altering the rooms array.
            guid: this.generateUUID(),
            ...room,
          });
        });
        this.activeRoom = this.getActiveRooms().length - 1;
      },
      getSummary(rooms, showRoomsCount = false) {
        let adults = 0;
        let children = 0;
        let pets = 0;
        let roomsCount = 0;
        rooms.forEach(room => {
          adults += room.adults;
          children += room.children_0_6 + room.children_7_12;
          pets += room.pets;
          if (room.adults !== 0) {
            roomsCount += 1;
          }
        });
        const output = `${adults} Adult${
          adults > 1 ? 's' : ''
        }, ${children} Child${children > 1 ? 'ren' : ''}
        , ${pets} Pet${pets > 1 ? 's' : ''}`;
        return showRoomsCount
          ? `${output} | ${roomsCount} Room${roomsCount > 1 ? 's' : ''}`
          : output;
      },
      getActiveRooms() {
        const firstInactiveIndex = this.rooms.findIndex(
          room => room.adults === 0,
        );
        if (firstInactiveIndex === -1) {
          return this.rooms;
        }
        return this.rooms.slice(0, firstInactiveIndex);
      },
      addRoom() {
        const firstInactiveIndex = this.rooms.findIndex(
          room => room.adults === 0,
        );
        this.rooms[firstInactiveIndex].adults = 2;
        this.activeRoom = firstInactiveIndex;
        this.totalRooms++;

        // Set the dropdown height and Scroll to the bottom of the selector.
        this.setDropdownHeight();
        setTimeout(() => {
          const scroll = document.getElementById('guests-selector__scroll');
          scroll.scrollTo({
            top: scroll.scrollHeight,
            behavior: 'smooth',
          });
        }, 500);
      },
      toggleActiveRoom(index) {
        this.activeRoom = this.activeRoom === index ? false : index;
      },
      updateRoom(index, property, change, element = null) {
        // Max 4 adults per room.
        if (property === 'adults') {
          if (this.rooms[index][property] + change > 4) {
            this.setTooltip(
              index,
              property,
              'Maximum occupancy reached. Please add an additional room.',
              element,
            );
            return;
          }
          // There must be at least 1 adult per room,
          if (this.rooms[index][property] + change < 1) {
            return;
          }
        }

        // Max 2 children per room.
        if (property === 'children_0_6' || property === 'children_7_12') {
          const totalChildren =
            this.rooms[index].children_0_6 + this.rooms[index].children_7_12;
          const newTotal = totalChildren + change;

          if (newTotal > 2) {
            this.setTooltip(
              index,
              property,
              'Maximum children reached. Please add an additional room.',
              element,
            );
            return;
          }

          // If less children, remove the last 'child age' dropdown.
          if (newTotal < totalChildren) {
            this.rooms[index][`${property}Ages`].pop();
          }
        }

        // Max 2 pets.
        if (property === 'pets') {
          if (this.rooms[index][property] + change > 2) {
            this.setTooltip(
              index,
              property,
              'Maximum pets reached. Please add an additional room.',
              element,
            );
            return;
          }
        }

        // Update the counter if the changed value is greater than or equal to 0.
        if (this.rooms[index][property] + change >= 0) {
          this.rooms[index][property] += change;
        }
      },
      removeRoom(index) {
        this.rooms.splice(index, 1);
        // Add an empty room to the end of the rooms array to replace the one that's been removed.
        this.rooms.push({
          guid: this.generateUUID(),
          adults: 0,
          children_0_6: 0,
          children_0_6Ages: [],
          children_7_12: 0,
          children_7_12Ages: [],
          pets: 0,
        });
        if (this.activeRoom === index) {
          this.activeRoom--;
        }
        this.totalRooms--;
      },
      setTooltip(index, property, message, element, addEvent = true) {
        this.tooltip = {
          index,
          property,
          message,
        };
        // Add a click handler that closes the tooltip.
        if (addEvent) {
          // $nextTick() needs to be used otherwise the click event will be executed as part of the click that sets the
          // tooltip.
          this.$nextTick(() => {
            // Unset the tooltip and remove the event listener to unset the tooltip if any element is clicked which
            // isn't the element which opened the tooltip.
            const unsetTooltip = event => {
              if (event.target !== element) {
                this.setTooltip(null, null, null, null, false);
                window.removeEventListener('click', unsetTooltip);
              }
            };
            window.addEventListener('click', unsetTooltip);
          });
        }
      },
      getTooltip(index, property) {
        if (
          this.tooltip.index === index &&
          this.tooltip.property === property
        ) {
          return this.tooltip.message;
        }
        return false;
      },
      toggleDropdown() {
        this.expanded = !this.expanded;

        const clickOutsideDropdown = event => {
          const dropdown = document.getElementById('guests-selector__dropdown');
          if (!dropdown.contains(event.target)) {
            this.expanded = false;
            window.removeEventListener('click', clickOutsideDropdown);
          }
        };

        if (this.expanded) {
          // Set the dropdown height and add event listeners to recalculate the height if the window is resized or
          // scrolled.
          window.addEventListener(
            'resize',
            _.debounce(this.setDropdownHeight, 150),
          );
          window.addEventListener(
            'scroll',
            _.debounce(this.setDropdownHeight, 150),
          );
          this.setDropdownHeight();

          // Prevent the page from scrolling when the guests selector is open on mobile.
          if (window.innerWidth < largeBreakpoint) {
            document.body.style.setProperty('overflow', 'hidden', 'important');
          }

          // Close the dropdown if clicked outside.
          this.$nextTick(() => {
            window.addEventListener('click', clickOutsideDropdown);
          });
        } else {
          window.removeEventListener(
            'resize',
            _.debounce(this.setDropdownHeight, 150),
          );
          window.removeEventListener(
            'scroll',
            _.debounce(this.setDropdownHeight, 150),
          );
          window.removeEventListener('click', clickOutsideDropdown);
          document.body.style.removeProperty('overflow');
        }

        // Lets the Booking flow behaviour know the status
        Drupal.DvhBookingEngine.BookingFormFlow.setGuestsOpenStatus(
          this.expanded,
        );
      },
      setDropdownHeight() {
        const scroll = document.getElementById('guests-selector__scroll');
        if (window.innerWidth < largeBreakpoint) {
          scroll.style.removeProperty('max-height');
        } else {
          const button = document.getElementById('guests-selector__button');
          const header = document.getElementById('guests-selector__header');
          scroll.style.setProperty(
            'max-height',
            `${window.innerHeight -
              button.getBoundingClientRect().bottom -
              header.offsetHeight}px`,
          );
        }
      },
    };
  };
})();
